import React, { useEffect } from 'react'

import { TAP_MAX_POINTER_TRAVEL } from './constants'
import LevelList from './level-list'
import LevelUnitsPanel from './level-units-panel'
import useExplorerLevels from './use-explorer-levels'

interface LevelExplorerProps {
  selectedLevelId: string
  onSelectLevel: (levelId: string) => void
  onSeeFloorplateView: (levelId: string) => void
  onSelectUnit: (levelId: string, unitName: string) => void
}

function LevelExplorer({
  selectedLevelId,
  onSelectLevel,
  onSeeFloorplateView,
  onSelectUnit,
}: LevelExplorerProps) {
  const { listLevels, matchingLevelsById, isFilterApplied } =
    useExplorerLevels()

  const selectedLevel = matchingLevelsById.get(selectedLevelId)

  useEffect(() => {
    if (selectedLevelId && !selectedLevel) {
      onSelectLevel('')
    }
  }, [selectedLevelId, selectedLevel, onSelectLevel])

  useEffect(() => {
    let pointerDownPosition = { x: 0, y: 0 }

    const handlePointerDown = (event: PointerEvent) => {
      pointerDownPosition = { x: event.clientX, y: event.clientY }
    }

    const handleCanvasTap = (event: MouseEvent) => {
      if (!(event.target instanceof HTMLCanvasElement)) {
        return
      }
      const pointerTravel = Math.hypot(
        event.clientX - pointerDownPosition.x,
        event.clientY - pointerDownPosition.y
      )
      if (pointerTravel > TAP_MAX_POINTER_TRAVEL) {
        return
      }
      onSelectLevel('')
    }

    document.addEventListener('pointerdown', handlePointerDown)
    document.addEventListener('click', handleCanvasTap)

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown)
      document.removeEventListener('click', handleCanvasTap)
    }
  }, [onSelectLevel])

  return (
    <>
      <LevelList
        levels={listLevels}
        selectedLevelId={selectedLevelId}
        onSelectLevel={onSelectLevel}
      />
      {selectedLevel && (
        <LevelUnitsPanel
          level={selectedLevel}
          isFilterApplied={isFilterApplied}
          onClose={() => onSelectLevel('')}
          onSeeFloorplateView={() => onSeeFloorplateView(selectedLevel.level)}
          onSelectUnit={(unit) => onSelectUnit(selectedLevel.level, unit.name)}
        />
      )}
    </>
  )
}

export default LevelExplorer
